import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/Menu_Bar.png'
import _imports_1 from '../assets/Search.png'
import _imports_2 from '../assets/ConnectToRobot.png'
import _imports_3 from '../assets/Build.png'
import _imports_4 from '../assets/Run.png'


const _hoisted_1 = { class: "heading-div" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon-button-img"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<button class=\"icon-button\"><img src=\"" + _imports_1 + "\" class=\"icon-button-img\"></button><div class=\"heading\">Simple View</div><button class=\"icon-button\"><img src=\"" + _imports_2 + "\" class=\"icon-button-img\"></button><button class=\"icon-button\"><img src=\"" + _imports_3 + "\" class=\"icon-button-img\"></button><button class=\"icon-button\"><img src=\"" + _imports_4 + "\" class=\"icon-button-img\"></button>", 5)
const _hoisted_9 = { class: "filetree-monaco-container" }
const _hoisted_10 = { class: "file-tree-column-container" }
const _hoisted_11 = { class: "sidebar" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h2", null, "Functions", -1)
const _hoisted_13 = { class: "open-text" }
const _hoisted_14 = {
  key: 0,
  class: "menu-bar"
}
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"menu-bar-item\">New Project</div><div class=\"menu-bar-item\">Current Project</div><div class=\"menu-bar-item\">Connect to Robot</div><div class=\"menu-bar-item\">Build Project</div><div class=\"menu-bar-item\">Run Project</div><div class=\"menu-bar-item\">Rename Project</div><div class=\"menu-bar-item\">Switch to pro view</div>", 7)
const _hoisted_22 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeBlock = _resolveComponent("CodeBlock")!
  const _component_CodeBlockFolder = _resolveComponent("CodeBlockFolder")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "icon-button",
        onClick: _cache[0] || (_cache[0] = () => (_ctx.openMenu = !_ctx.openMenu))
      }, _hoisted_3),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_CodeBlockFolder, { title: "Movements" }, {
            default: _withCtx(() => [
              _createVNode(_component_CodeBlock, { title: "Move Forward" }),
              _createVNode(_component_CodeBlock, { title: "Move Backward" }),
              _createVNode(_component_CodeBlock, { title: "Turn Left" }),
              _createVNode(_component_CodeBlock, { title: "Turn Right" }),
              _createVNode(_component_CodeBlock, { title: "Turn Stop" }),
              _createVNode(_component_CodeBlock, { title: "Drive" })
            ]),
            _: 1
          }),
          _createVNode(_component_CodeBlockFolder, { title: "Controls" }, {
            default: _withCtx(() => [
              _createVNode(_component_CodeBlock, { title: "For Loop" }),
              _createVNode(_component_CodeBlock, { title: "If Statement" }),
              _createVNode(_component_CodeBlock, { title: "While Statement" }),
              _createVNode(_component_CodeBlock, { title: "Switch Statement" })
            ]),
            _: 1
          }),
          _createVNode(_component_CodeBlockFolder, { title: "Sensing" }, {
            default: _withCtx(() => [
              _createVNode(_component_CodeBlock, { title: "Detect Colour" }),
              _createVNode(_component_CodeBlock, { title: "Start Mapping" }),
              _createVNode(_component_CodeBlock, { title: "Save Map" }),
              _createVNode(_component_CodeBlock, { title: "Start Navigation" }),
              _createVNode(_component_CodeBlock, { title: "Navigate To" }),
              _createVNode(_component_CodeBlock, { title: "Distance" }),
              _createVNode(_component_CodeBlock, { title: "Compass" }),
              _createVNode(_component_CodeBlock, { title: "Left Sensor Value" }),
              _createVNode(_component_CodeBlock, { title: "Right Sensor Value" })
            ]),
            _: 1
          }),
          _createVNode(_component_CodeBlockFolder, { title: "Sensing" }, {
            default: _withCtx(() => [
              _createTextVNode(" Add your own self defined code blocks here ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.openText), 1)
      ]),
      _createElementVNode("div", {
        id: "editor",
        class: "editor-style",
        onDrop: _cache[1] || (_cache[1] = (e) => _ctx.onEditorDrop(e)),
        dropzone: "true"
      }, null, 32),
      (_ctx.openMenu)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_22))
        : _createCommentVNode("", true)
    ])
  ], 64))
}